export default __webpack_public_path__ + "static/meshmap-cluster2-98abf7107400581278b61b40eeb4c2ec.webp";